import React, { useEffect, useState } from "react";

import { FarmerType, generateRandomNumber, useTranslation } from "utils";

import { Anchor, Flex, LazyLoadImage, Svg, Typography } from "components";

interface TestimonialScreenProps {
  farmerType: FarmerType;
}

interface Testimonial {
  name: string;
  img: string;
  quote: string;
  source: string;
}

const getImage = (farmerType: FarmerType, testimonial: Testimonial) => {
  // TODO: Replace with dairy and meat related images that aren't AI generated
  if (farmerType === "dairy" || farmerType === "meat") return "/images/intro/split_screen_intro.jpg";
  return `/images/intro/testimonials/${testimonial.img.toLowerCase().replace(" ", "-").replace(".jpg", "")}.jpg`;
};

export const TestimonialScreen = ({ farmerType }: TestimonialScreenProps) => {
  const { t } = useTranslation("intro");
  const [testimonialIndex, setTestimonialIndex] = useState<number | undefined>();

  const getTestimonials = (): Testimonial[] => t(`testimonialsArray.${farmerType}`, { returnObjects: true }) as Testimonial[];

  const testimonials = getTestimonials();

  useEffect(() => {
    if (testimonialIndex !== undefined) return;
    if (!Array.isArray(testimonials)) return;
    setTestimonialIndex(generateRandomNumber(0, testimonials.length));
  }, [testimonials, testimonialIndex]);

  const testimonial = testimonialIndex !== undefined ? testimonials[testimonialIndex] : undefined;

  return (
    <>
      {testimonial && (
        <div className="testimonials-screen">
          {/* this annoying line of code ensures that the image is loaded even if the translation key is incorrect */}
          <LazyLoadImage alt={testimonial.name} src={getImage(farmerType, testimonial)} />
          <Flex vertical gap={32} className="container">
            <Anchor href="https://www.klim.eco/en/farmers/platform" target="_self">
              <Svg svgName="logos/klim_logo_text_black" width={75} height={32} />
            </Anchor>
            <div className="quote-box">
              <Svg svgName="intro/quote" width={48} height={48} />
              <Typography variant="h3">{testimonial.quote}</Typography>
              <Typography variant="paragraph-m">{testimonial.source}</Typography>
            </div>
          </Flex>
        </div>
      )}
    </>
  );
};
